import React, { useEffect, useState } from "react";
import { getMyBusyWeeks } from "./happyschoolApi";
import HappySchoolVanhoaDistribution from "./HappySchoolVanhoaDistribution";

// GV tự xem "Lịch phân phối nghề-văn hoá" — cùng danh sách tuần đang mở khai
// báo bận. Mặc định chỉ xem; riêng nhóm "Giáo vụ" (canImportVanhoaNghe=true)
// được bấm "✏️ Sửa" ngay trên Bản chính (lưu vào bản đang chờ duyệt) hoặc
// Nhập Excel — vẫn không được Duyệt, chỉ Owner mới duyệt vào bản chính.
const HappySchoolMyVanhoaNghe = ({ schoolId, canImport }) => {
  const [weeks, setWeeks] = useState([]);
  const [weekId, setWeekId] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!schoolId) return;
    setLoading(true);
    setError("");
    getMyBusyWeeks(schoolId)
      .then((ws) => {
        const sorted = (ws || []).slice().sort((a, b) => (b.startDate || "").localeCompare(a.startDate || ""));
        setWeeks(sorted);
        if (sorted.length) setWeekId(sorted[0].id);
      })
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, [schoolId]);

  if (loading) return <p>Đang tải...</p>;
  if (error) return <p style={{ color: "#dc2626" }}>{error}</p>;
  if (weeks.length === 0) return <p style={{ color: "#b45309" }}>Chưa có tuần thời khoá biểu nào đang mở. Chờ nhà trường mở khai báo.</p>;

  return (
    <div>
      {weeks.length > 1 && (
        <div style={{ display: "flex", gap: 10, alignItems: "center", marginBottom: 14, flexWrap: "wrap" }}>
          <span style={{ fontSize: 13, fontWeight: 600, color: "#4b5563" }}>Tuần TKB:</span>
          <select value={weekId} onChange={(e) => setWeekId(e.target.value)} style={{ padding: 8, minWidth: 240 }}>
            {weeks.map((w) => (
              <option key={w.id} value={w.id}>
                {(w.startDate || "?") + " → " + (w.endDate || "?")}{(w.khois && w.khois.length) ? ` (Khối ${w.khois.join(",")})` : ""}
              </option>
            ))}
          </select>
        </div>
      )}
      <HappySchoolVanhoaDistribution weekId={weekId} readOnly={!canImport} />
    </div>
  );
};

export default HappySchoolMyVanhoaNghe;
